import PropTypes from "prop-types";
import React from "react";

import { CustomMenu, CustomMenuList } from "./Menu.styled";

export { CustomMenuList };

const Menu = ({ children, innerRef, innerProps, menuTop }) => (
  <CustomMenu ref={innerRef} {...innerProps} $menuTop={menuTop}>
    {children}
  </CustomMenu>
);

Menu.propTypes = {
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
  ]),
  children: PropTypes.node,
  menuTop: PropTypes.number,
};

export default Menu;
